// First, last and the neighbours of the current page, with gaps marked. Bounded
// however many pages exist, so a pager never grows with the library.
export const pagerItems = (page, count) => {
  const keep = new Set([1, count, page - 1, page, page + 1]);
  const nums = [...keep].filter((n) => n >= 1 && n <= count).sort((a, b) => a - b);
  const items = [];
  nums.forEach((n, i) => {
    if (i > 0 && n - nums[i - 1] > 1) items.push({ gap: `gap-${n}` });
    items.push({ n });
  });
  return items;
};
